import information_json from "@public/assets_default/data/information.json"
//TEST用↑
export function createNewsState(filterCondition) {
  let newsList = $state([]);
  let isLoading = $state(true);
  let error = $state(null);

  $effect(() => {
    const fetchNews = async () => {
      isLoading = true; // フェッチ開始時にローディング状態をtrueに
      error = null; // エラーをリセット
      try {
        // const response = await fetch('https://corporate.minna-no-ginko.com/common/data/information.json');
        // if(!response.ok) throw new Error('corporate-news.jsonデータの取得に失敗しました');
        // const data = await response.json();
        // let allNews = data.information;

        //TEST用↓
        let allNews = information_json.information;

        newsList = allNews.filter(filterCondition).sort((a, b) => new Date(b.date) - new Date(a.date));
      } catch (error) {
        console.error(error);
        error = 'お知らせの取得に失敗しました。';
      } finally {
        isLoading = false; // フェッチ完了時にローディング状態をfalseに
      }
    };
    fetchNews();
  });

  return {
    get newsList() { return newsList; },
    get isLoading() { return isLoading; },
    get error() { return error; },
  };
}